import createActionTypes from 'shared/app/state/create-action-types';

export const { FETCH_STREAM, FETCH_STREAM_SUCCESS, FETCH_STREAM_ERROR } =
  createActionTypes(['FETCH_STREAM']);

export const ONBOARDING_COMPLETED_TASK_SEEN = 'ONBOARDING_COMPLETED_TASK_SEEN';
